export function isWeixin() {
    var ua = navigator.userAgent.toLowerCase();
    console.log(ua)
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        // return process.env.NODE_ENV !== 'production' ? true : false;
        return false;
    }
}
/**
 * 判断访问地址和终端是否一致，如果一致，则退出不执行, 反之则跳转到对应的终端下的页面 【如访问移动端，但终端在pc 则url重新链接到pc对应的页面】
 * 包含：【排行榜页、邀请函—展商详情页、活动详情页、展品详情页、云名片详情页】
 * @param {*} that that为vue的实例
 */
export function isPc(that) { // 
    const isCurMobile = that.$store.state.isCurMobile; // 获取当前是否手机端
    const curUlr = that.$router.history.current.fullPath; // 当前url
    const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|WindowsWechat/i.test(navigator.userAgent); // 判断是否手机端 
    // const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent); // 判断是否手机端 
    console.log(`当前是${isMobile ? '移动端' : 'pc端'}`);
    if(!isMobile){ // 不是手机端
        let url = location.origin + "/503"
        // window.location.href = url;
        // that.$router.push({ path: '/503'});
        let pathname=window.location.pathname;
        if(pathname.indexOf('video-talk')==-1){
            that.$toast('View on phone');
        }
        return;
    }
    // if (isCurMobile === isMobile) return; // 判断访问地址和终端是否一致 
    // if (curUlr.search('undefined') !== -1) return;  // 如果地址里有undefined 退出
    // console.log(`当前是${isCurMobile ? '移动端' : 'pc端'}`);
    // window.location.href = urlPrefxi + pathname;
}
